export const ROLE_DIALOG_SETTINGS = {
  maxHeight: '90vh',
  height: '18.75rem',
  panelClass: 'people-role-dialog',
  // disableClose: true,
};
